import React from 'react';
import { Modal } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import '../common/LookupModal.css';
import { preventLookupSearchBubbling } from '../common/lookupSearchEvents';
import * as constantClass from '../fileWithConstants';
import {
  LOOKUP_PAGE_SIZE,
  fetchAndApplyIndexPage,
  isIndexInitialLoading,
} from '../../services/mdServerIndex';

function SearchIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-4-4" />
    </svg>
  );
}

export class LookupAlumnos extends React.Component {
  constructor(props) {
    super(props);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.handleItemSelect = this.handleItemSelect.bind(this);
    this.searchInputRef = React.createRef();
    this.state = {
      show: true,
      loading: true,
      searchInput: '',
      perPage: LOOKUP_PAGE_SIZE,
      paginationData: [],
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
    };
  }

  handleModal() {
    this.setState({ show: !this.state.show });
    this.props.hideLookup();
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWAlumnos');
    if (canAccess) {
      this.populateData();
    }
  }

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleItemSelect = (alumno) => {
    this.props.selectStudent(
      alumno.alumnoDni + '%' + alumno.alumnoNombre + '%' + alumno.alumnoCodigo
    );
    this.setState({ show: false });
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  handleSearchSubmit = (e) => {
    preventLookupSearchBubbling(e);
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  renderTable(alumnos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="lookup-alumnos-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => (
              <tr key={alumno.alumnoCodigo}>
                <td>{alumno.alumnoDni}</td>
                <td>{alumno.alumnoNombre}</td>
                <td>
                  <button
                    type="button"
                    className="md-page__btn md-page__btn--primary"
                    onClick={() => this.handleItemSelect(alumno)}
                  >
                    Seleccionar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = isIndexInitialLoading(this.state);

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <Modal
        size="lg"
        className="lookup-modal"
        show={this.state.show}
        onHide={() => this.handleModal()}
      >
        <Modal.Header>
          <Modal.Title id="lookup-alumnos-title">Seleccionar el Alumno</Modal.Title>
          <button
            type="button"
            className="lookup-modal__close"
            onClick={() => this.handleModal()}
            aria-label="Cerrar"
          >
            x
          </button>
        </Modal.Header>
        <Modal.Body>
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}

          <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
            <div className="md-page__search-wrap">
              <span className="md-page__search-icon">
                <SearchIcon />
              </span>
              <input
                ref={this.searchInputRef}
                className="md-page__search-input"
                type="text"
                name="search"
                autoComplete="off"
                disabled={isBusy}
                placeholder="Ingrese DNI o Apellido del alumno"
                value={this.state.searchInput}
                onChange={this.handleSearchInputChange}
              />
            </div>
            <button type="submit" className="md-page__search-btn" disabled={isBusy}>
              Buscar
            </button>
          </form>

          {contents}

          {!listLoading && this.state.pageCount > 0 ? (
            <div className="md-page__pagination">
              <ReactPaginate
                previousLabel="Anterior"
                nextLabel="Siguiente"
                breakLabel="..."
                breakClassName="break-me"
                pageCount={this.state.pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                forcePage={Math.floor(this.state.offset / this.state.perPage)}
                onPageChange={this.handlePageClick}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active"
              />
            </div>
          ) : null}
        </Modal.Body>
      </Modal>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/Students/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }
}
